import { Link } from 'react-router-dom';
import { useAnalysesQuery } from '../../api/queries/analyses';
import { useErrorToast } from '../../lib/useErrorToast';
import { PlusCircle } from '@phosphor-icons/react';

export function AppMenu() {
  const analysesQuery = useAnalysesQuery();
  const analyses = analysesQuery.data?.analyses.slice(0, 5) || [];

  useErrorToast(analysesQuery.error);

  return (
    <div className="bg-white border-r h-full p-4 w-52">
      <div className="flex flex-col gap-8">
        {/* Analyses  */}
        <div>
          <div className="flex justify-between items-center mb-2">
            <Link
              to="/a"
              className="bold w-full text-xl font-terminal hover:shadow-[inset_0_-1px_0px_black] border-black hover:text-orange-2"
            >
              Analyses
            </Link>
            <Link to="/">
              <PlusCircle
                size={20}
                className="text-black hover:text-orange-2"
              />
            </Link>
          </div>
          {analysesQuery.data && (
            <ul className="pl-2">
              {analyses.map((analysis) => (
                <li key={analysis.id}>
                  <Link
                    className="hover:shadow-[inset_0_-1px_0px_black] hover:text-orange-2"
                    to={`/a/${analysis.slug}`}
                  >
                    {analysis.name}
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </div>
        {/* Actions */}
        <div>
          <div className="flex justify-between items-center mb-2">
            <Link
              to="/actions/create"
              className="bold w-full text-xl font-terminal hover:shadow-[inset_0_-1px_0px_black] border-black hover:text-orange-2"
            >
              Actions
            </Link>
            <Link to="/actions/create">
              <PlusCircle
                size={20}
                className="text-black hover:text-orange-2"
              />
            </Link>
          </div>
        </div>
        {/* Files  */}
        <Link
          to="/files"
          className="bold w-full text-xl font-terminal hover:shadow-[inset_0_-1px_0px_black] hover:text-orange-2"
        >
          Files
        </Link>
      </div>
    </div>
  );
}
